import React from 'react';
import classnames from 'classnames';

import PropTypes from 'prop-types';

import { formatNumeric } from '../../../../util';

import styles from './index.scss';

const LoadingFigureSection = () => {
  return (
    <div className={classnames('row', styles.figuresSection)}>
      <div className={classnames('col-md-12', styles.figuresContainer)}>
        <h5 className={styles.messageItem}>Loading figures...</h5>
      </div>
    </div>
  );
};

const NoDataFigureSection = ({ onReload }) => {
  return (
    <div className={classnames('row', styles.figuresSection)}>
      <div className={classnames('col-md-12', styles.figuresContainer)}>
        <h5 className={styles.messageItem}>
          No data is present for the period selected.
          <br />
          <a className={styles.retryLink} onClick={onReload}>
            Click here to fetch figure data again.
          </a>
        </h5>
      </div>
    </div>
  );
};

const FigureItem = ({ current, previous, title, isPercentage }) => {
  let caretClass = '';
  let fontAwesomeCaretClass = '';

  if (current === previous) {
    caretClass = '';
    fontAwesomeCaretClass = '';
  }

  if (current > previous) {
    caretClass = styles.caretUp;
    fontAwesomeCaretClass = 'fa fa-caret-up';
  }

  if (current < previous) {
    caretClass = styles.caretDown;
    fontAwesomeCaretClass = 'fa fa-caret-down';
  }

  return (
    <div className={styles.figureItem}>
      <p className={styles.figureTitle}>{title}</p>
      <p className={styles.figureCount}>
        {formatNumeric(current)} {isPercentage ? '%' : ''}{' '}
        <i className={classnames(fontAwesomeCaretClass, caretClass)}></i>
      </p>
      <p className={styles.previousFigureCount}>
        {formatNumeric(previous)} {isPercentage ? '%' : ''}
      </p>
    </div>
  );
};

export const FiguresSection = (props) => {
  const { data, isLoading, onReload } = props;

  if (isLoading) {
    return <LoadingFigureSection />;
  }

  if (data) {
    const {
      hitsYield,
      l1,
      totalAlerts,
      totalFalseHits,
      totalHits,
      totalTrueHits,
      undetermined
    } = data;
    return (
      <div className={classnames('row', styles.figuresSection)}>
        <div className={classnames('col-md-12', styles.figuresContainer)}>
          <FigureItem
            current={
              totalAlerts !== undefined &&
              totalAlerts !== null &&
              totalAlerts.current !== undefined &&
              totalAlerts.current !== null
                ? totalAlerts.current
                : 0
            }
            previous={
              totalAlerts !== undefined &&
              totalAlerts !== null &&
              totalAlerts.previous !== undefined &&
              totalAlerts.previous !== null
                ? totalAlerts.previous
                : 0
            }
            title="Total Alerts"
          />
          <FigureItem
            current={
              l1 !== undefined &&
              l1 !== null &&
              l1.current !== undefined &&
              l1.current !== null
                ? l1.current
                : 0
            }
            previous={
              l1 !== undefined &&
              l1 !== null &&
              l1.previous !== undefined &&
              l1.previous !== null
                ? l1.previous
                : 0
            }
            title="L1 Alerts"
          />
          <FigureItem
            current={
              totalHits !== undefined &&
              totalHits !== null &&
              totalHits.current !== undefined &&
              totalHits.current !== null
                ? totalHits.current
                : 0
            }
            previous={
              totalHits !== undefined &&
              totalHits !== null &&
              totalHits.previous !== undefined &&
              totalHits.previous !== null
                ? totalHits.previous
                : 0
            }
            title="Total Hits"
          />
          <FigureItem
            current={
              totalFalseHits !== undefined &&
              totalFalseHits !== null &&
              totalFalseHits.current !== undefined &&
              totalFalseHits.current !== null
                ? totalFalseHits.current
                : 0
            }
            previous={
              totalFalseHits !== undefined &&
              totalFalseHits !== null &&
              totalFalseHits.previous !== undefined &&
              totalFalseHits.previous !== null
                ? totalFalseHits.previous
                : 0
            }
            title="Total False Hits"
          />
          <FigureItem
            current={
              totalTrueHits !== undefined &&
              totalTrueHits !== null &&
              totalTrueHits.current !== undefined &&
              totalTrueHits.current !== null
                ? totalTrueHits.current
                : 0
            }
            previous={
              totalTrueHits !== undefined &&
              totalTrueHits !== null &&
              totalTrueHits.previous !== undefined &&
              totalTrueHits.previous !== null
                ? totalTrueHits.previous
                : 0
            }
            title="Total True Hits"
          />
          <FigureItem
            current={
              undetermined !== undefined &&
              undetermined !== null &&
              undetermined.current !== undefined &&
              undetermined.current !== null
                ? undetermined.current
                : 0
            }
            previous={
              undetermined !== undefined &&
              undetermined !== null &&
              undetermined.previous !== undefined &&
              undetermined.previous !== null
                ? undetermined.previous
                : 0
            }
            title="Undetermined Hits"
          />
          <FigureItem
            current={
              hitsYield !== undefined &&
              hitsYield !== null &&
              hitsYield.current !== undefined &&
              hitsYield.current !== null
                ? hitsYield.current
                : 0
            }
            previous={
              hitsYield !== undefined &&
              hitsYield !== null &&
              hitsYield.previous !== undefined &&
              hitsYield.previous !== null
                ? hitsYield.previous
                : 0
            }
            title="Hits Yield"
          />
        </div>
      </div>
    );
  }

  return <NoDataFigureSection onReload={onReload} />;
};

FiguresSection.propTypes = {
  data: PropTypes.object,
  isLoading: PropTypes.bool,
  onReload: PropTypes.func
};
